import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from 'react-i18next';

import { selectIsModalDiagramCreateNewEnabled } from '../../../redux/main/main.selectors';
import { toggleDiagramCreateNew, addNewDiagram } from '../../../redux/main/main.actions';


import Modal from '../Modal/Modal';

import './ModalDiagramCreateNew.scss';

export const ModalDiagramCreateNew = () => {
    const dispatch = useDispatch();
const { t, i18n } = useTranslation();

    const isOpen = useSelector(selectIsModalDiagramCreateNewEnabled);

    const [selectedDb, setSelectedDb] = useState('postgresql');

    const handleCancel = () => {
        dispatch(addNewDiagram(selectedDb));
        dispatch(toggleDiagramCreateNew());

        setTimeout(() => {
            setSelectedDb('postgresql');
        }, 300);
    };

    const handleCreate = () => {
        if (selectedDb) {
            setTimeout(() => {
                dispatch(addNewDiagram(selectedDb));
                dispatch(toggleDiagramCreateNew());
            }, 50);
            setTimeout(() => {
                setSelectedDb('postgresql');
            }, 300);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-diagram-create-new`}
            onCancel={handleCancel}
        >
            {/* <div className="modal-content-header">{`Let's build something new`}</div> */}
            <div className="modal-content-body">

                <div className='section-group'>
                    <div className='section-group-item'>
                        <div className='section-group-item-title'>{t('m_new_diagram.title')}</div>

                        <div className="section-group-item-title second">{t('m_new_diagram.subtitle')}</div>

                        <div className='left-group right'>
                            <div className='right-group'>
                                <div className={`left-group-item import ${selectedDb === 'mysql' ? 'selected' : ''}`} onClick={() => setSelectedDb('mysql')}>
                                    MySQL
                                </div>
                                <div className={`left-group-item import ${selectedDb === 'postgresql' ? 'selected' : ''}`} onClick={() => setSelectedDb('postgresql')}>
                                    PostgreSQL
                                </div>
                                <div className={`left-group-item import ${selectedDb === 'sqlserver' ? 'selected' : ''}`} onClick={() => setSelectedDb('sqlserver')}>
                                    SQL Server
                                </div>
                            </div>
                            <div className='right-group'>
                                <div className={`left-group-item import ${selectedDb === 'oracle' ? 'selected' : ''}`} onClick={() => setSelectedDb('oracle')}>
                                    Oracle
                                </div>
                                <div className={`left-group-item import ${selectedDb === 'sqlite' ? 'selected' : ''}`} onClick={() => setSelectedDb('sqlite')}>
                                    SQLite
                                </div>
                                <div className={`left-group-item import ${selectedDb === 'mariadb' ? 'selected' : ''}`} onClick={() => setSelectedDb('mariadb')}>
                                    MariaDB
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                {/* <div className="description-text">Enter a new diagram name</div>
                <input
                    autoComplete="off"
                    ref={inputRef}
                    spellCheck="false"
                    type="text"
                    id="board-name"
                    placeholder="Enter diagram name"
                    value={'New Diagram'}
                // onChange={(e) => setName(e.target.value)}
                /> */}


                <div className='buttons-section'>
                    <button onClick={() => handleCreate()}>{t('m_new_diagram.open_diagram')}</button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalDiagramCreateNew;
